"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var utils_1 = __importDefault(require("../utils"));
var enums_1 = require("../types/enums");
var actions_1 = __importDefault(require("../actions"));
var selectors_1 = __importDefault(require("../selectors"));
var useSlotDetailsData = function (_a) {
    var slotStartTime = _a.slotStartTime, channelId = _a.channelId, skipClearWhenUnmount = _a.skipClearWhenUnmount, _b = _a.needReverseEPG, needReverseEPG = _b === void 0 ? false : _b, _c = _a.isPPV, isPPV = _c === void 0 ? false : _c;
    var _d, _e, _f, _g;
    var dispatch = react_redux_1.useDispatch();
    var isLoading = react_redux_1.useSelector(selectors_1.default.epg.selectedSlotIsLoading);
    var selectedSlot = react_redux_1.useSelector(selectors_1.default.epg.selectedSlot);
    var selectedSlotChannel = react_redux_1.useSelector(selectors_1.default.epg.selectedSlotChannel);
    var isLoadingError = react_redux_1.useSelector(selectors_1.default.epg.selectedSlotError);
    var brand = utils_1.default.slot.isShow(selectedSlot)
        ? (_d = selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.programme) === null || _d === void 0 ? void 0 : _d.show : selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.programme;
    if (isPPV) {
        brand = (_e = selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.programme) === null || _e === void 0 ? void 0 : _e.event;
    }
    var isShow = utils_1.default.slot.isShow(selectedSlot);
    var isSport = utils_1.default.slot.isSport(selectedSlot);
    var isOnAir = selectedSlot && utils_1.default.slot.isSlotOnAir(selectedSlot);
    var title = utils_1.default.slot.getSlotTitle(selectedSlot);
    var image = (_f = brand === null || brand === void 0 ? void 0 : brand[enums_1.ImageAssetType.ContentTileHorizontal]) === null || _f === void 0 ? void 0 : _f.uri;
    var synopsis = utils_1.default.title.getProgrammeSynopsis(selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.programme, brand); // fallback to brand's synopsis when episode doesn't have
    var isRecordable = utils_1.default.slot.isRecordable(selectedSlot);
    var isSlotEntitled = utils_1.default.entitlements.isChannelEntitled(selectedSlotChannel);
    var vodAsset = (_g = selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.programme) === null || _g === void 0 ? void 0 : _g.asset;
    var isVodEntitled = utils_1.default.entitlements.isVodEntitled(selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.programme);
    react_1.useEffect(function () {
        if (slotStartTime &&
            channelId
        // TODO avoid duplicated fetch, this would fail the acceptance test for RN, as the mock server always return the different slot.
        // !(selectedSlot?.start === slotStartTime && selectedSlot?.channel?.id === channelId)
        ) {
            dispatch(actions_1.default.epg.fetchSlotByStartTime({ channelId: channelId, slotStartTime: slotStartTime, needReverseEPG: needReverseEPG, isPPV: isPPV }));
        }
    }, [dispatch, slotStartTime, channelId, needReverseEPG, isPPV]);
    react_1.useEffect(function () { return function () {
        if (!skipClearWhenUnmount) {
            dispatch(actions_1.default.epg.clearSelectedSlot());
        }
    }; }, [dispatch, skipClearWhenUnmount]);
    return {
        isLoading: isLoading,
        isLoadingError: isLoadingError,
        title: title,
        image: image,
        synopsis: synopsis,
        isOnAir: isOnAir,
        isShow: isShow,
        isSport: isSport,
        isPPV: isPPV,
        isRecordable: isRecordable,
        isSlotEntitled: isSlotEntitled,
        isVodEntitled: isVodEntitled,
        brand: brand,
        slot: selectedSlot,
        vodAsset: vodAsset,
    };
};
exports.default = useSlotDetailsData;
//# sourceMappingURL=useSlotDetailsData.js.map